//#region src/assets/throbber.svg
var throbber_default = "" + new URL("throbber-CA1Noqfr.svg", import.meta.url).href;
//#endregion
export { throbber_default as default };

//# sourceMappingURL=throbber.js.map